module.exports = __webpack_public_path__ + "media/images/button-left-37bbbc0117aefd5e753c71877730b4ed.png";